// @ts-expect-error Untyped module
import HighlightCommandPopoverManager from '../../components/HighlightCommandPopoverManager';
import { __HS_COPILOT_COLLABORATION } from '../../constants/plugins';
// @ts-expect-error Untyped module
import tinymce from 'tinymce';
import { jsx as _jsx } from "react/jsx-runtime";
export const addControls = (editor, highlightCommands, brandVoiceOptions) => {
  tinymce.canvas.addPopover(editor, __HS_COPILOT_COLLABORATION, {
    renderPopover: renderProps => {
      return /*#__PURE__*/_jsx(HighlightCommandPopoverManager, Object.assign({
        brandVoiceOptions: brandVoiceOptions,
        "data-test-id": "highlight-commands-popover",
        commands: highlightCommands,
        editor: editor
      }, renderProps));
    }
  });
};